import { sortDateDesc } from '@strata/helper-functions';
import { BaseNotification } from '@strata/react-notifications';

import { SocketType, wsSend } from 'services/socketHelpers';
import {
    addNotifications,
    removeFromList,
    setIncomingNotification,
    setNotificationStatuses,
} from 'store/notification/notificationSlice';

export const receiveNewNotifications = (notifications) => (dispatch, getState) => {
    const { notification } = getState();
    const existingNotificationIds = notification.notifications.map((obj) => obj.id);
    const newNotifications = Array.from(notifications)
        .filter(
            (newNotification) => !existingNotificationIds.includes(newNotification.notification_id),
        )
        .map((newNotification) => ({
            id: newNotification.notification_id,
            type: newNotification.notification_type,
            linkingId: newNotification.linking_id,
            payerId: newNotification.payer_id,
            segmentId: newNotification.segment_id,
            timestamp: newNotification.notification_time,
            status: newNotification.interaction_status,
            patientName: newNotification.patient_name,
            productName: newNotification.product_name,
            productServiceOid: newNotification.product_service_oid,
            additionalData: newNotification.additional_info,
        }))
        .sort((a, b) => sortDateDesc(a.timestamp, b.timestamp));

    if (notification.notificationsLoaded && newNotifications.length > 0) {
        newNotifications.forEach((incomingNotification) =>
            dispatch(setIncomingNotification({ incomingNotification })),
        );
    }

    dispatch(addNotifications({ newNotifications }));
};

export const updateNotificationStatuses = (status, notificationIds) => (dispatch) => {
    dispatch(
        wsSend({
            socketType: SocketType.NOTIFICATION,
            messageType: status,
            message: notificationIds,
        }),
    );

    if (status === BaseNotification.Statuses.DELETED) {
        dispatch(removeFromList({ notificationIds }));
    } else {
        dispatch(setNotificationStatuses({ notificationIds, status }));
    }
};

export const updateNotificationStatus = (status, notificationId) => (dispatch) => {
    if (notificationId) {
        dispatch(updateNotificationStatuses(status, [notificationId]));
    }
};

export const clearIncomingNotification = () => (dispatch) => {
    dispatch(setIncomingNotification({ incomingNotification: null }));
};
